import { queryClient } from "@/lib/queryClient";
import { resetApiSessionScope } from "@/lib/api";

const ACCOUNT_LOCAL_KEYS = [
  "cc.selectedCruiseId",
  "cc.family_sharing.ftue.dismissed_at",
  "cc.rc7.m7.outbox.v1",
];

export function clearAccountScopedState() {
  resetApiSessionScope();
  queryClient.clear();
    if (typeof window !== 'undefined' && window.sessionStorage) {
      for (let i = window.sessionStorage.length - 1; i >= 0; i -= 1) {
        const key = window.sessionStorage.key(i);
        if (key?.startsWith('cc-mobile-voyage-expanded-days') || key === 'cc_post_login_hash') {
          window.sessionStorage.removeItem(key);
        }
      }
    }
  try {
    ACCOUNT_LOCAL_KEYS.forEach((key) => window.localStorage.removeItem(key));
  } catch { /* storage unavailable */ }
}